import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { PURGE } from "redux-persist";

const initialState = {
  language: "",
  brand: "",
  header: "",
  country: "",
  keycloakLocale:""
};

export const PersistSlice = createSlice({
  name: "persistDetails",
  initialState,
  reducers: {
    updateLanguage: (state, action: PayloadAction<any>) => {
      state.language = action.payload;
    },
    updateBrand: (state, action: PayloadAction<any>) => {
      state.brand = action.payload;
    },
    showHeader: (state, action: PayloadAction<any>) => {
      state.header = action.payload;
    },
    updateCountry: (state, action: PayloadAction<any>) => {
      state.country = action.payload;
    },
    updateKeycloakLocale: (state, action: PayloadAction<string>) => {
      state.keycloakLocale = action.payload;
    }
  },
  extraReducers: builder => {
    builder.addCase(PURGE, () => {
      return initialState;
    });
  },
});

export const { updateLanguage, updateBrand, showHeader, updateCountry,
  updateKeycloakLocale } = PersistSlice.actions;
export const PersistState = (state: RootState) => state.persistDetails;
export default PersistSlice.reducer;
